import { Component } from '@angular/core';
import { ComponentsModule } from '@mastechnicaegroup/carelinelive-ui';
import { HeaderComponent } from '@shared/layout/header/header.component';

@Component({
    selector: 'app-setting-positions-index-page',
    imports: [
        ComponentsModule,
        HeaderComponent
    ],
    templateUrl: './setting-positions-index-page.component.html',
    standalone: true,
    styleUrl: './setting-positions-index-page.component.scss'
})
export class SettingPositionsIndexPageComponent {
}

